import AudioControl from './components/AudioControl';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Snowman from 'games/snowman';

function App() {
  return (
    <Router>
      <div className='App'>
        <AudioControl />
        <Routes>
          <Route path='/*' element={<Snowman />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
